export default "__VITE_ASSET__CFpnNLBB__"